document.addEventListener('alpine:init', () => {
  var { getScript } = Alpine.store('utilities');

  function productFormLogoFile(data = {}) {
    return {
      ...data,

      onIntersectLogoFile() {
        var uploadcareScriptUrl = 'https://ucarecdn.com/libs/widget/3.x/uploadcare.full.min.js';

        getScript((uploadcareScriptUrl), () => {
          var widget = uploadcare.Widget(this.$refs.inputLogoFile);

          widget.onUploadComplete(() => {
            this.$refs.inputLogoFile.dispatchEvent(new CustomEvent('input'))
          });
        });
      }
    };
  };

  Alpine.data('productFormLogoFile', productFormLogoFile);
});
